import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';

// Async thunks
export const fetchDeliveries = createAsyncThunk(
  'deliveries/fetchDeliveries',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getUserDeliveries();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch deliveries');
    }
  }
);

export const fetchDeliveryDetails = createAsyncThunk(
  'deliveries/fetchDeliveryDetails',
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.getDeliveryDetails(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch delivery details');
    }
  }
);

// Delivery slice
const deliverySlice = createSlice({
  name: 'deliveries',
  initialState: {
    deliveries: [],
    selectedDelivery: null,
    loading: false,
    error: null,
  },
  reducers: {
    selectDelivery: (state, action) => {
      state.selectedDelivery = action.payload;
    },
    clearSelectedDelivery: (state) => {
      state.selectedDelivery = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchDeliveries
      .addCase(fetchDeliveries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeliveries.fulfilled, (state, action) => {
        state.loading = false;
        state.deliveries = action.payload;
      })
      .addCase(fetchDeliveries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // fetchDeliveryDetails
      .addCase(fetchDeliveryDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeliveryDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedDelivery = action.payload;
      })
      .addCase(fetchDeliveryDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { selectDelivery, clearSelectedDelivery } = deliverySlice.actions;

export default deliverySlice.reducer;
